export const lightTheme = {
  name: 'light',

  primaryColor: '#F4A261',
  primaryDark: '#E76F51',
  secondaryColor: '#F9C98B',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#F4A261',

  bgPrimary: '#ffffff',
  bgSecondary: '#FFFAF5',
  bgTertiary: '#FFF0E0',

  background: '#FFF0E0',
  cardBackground: '#ffffff',
  hoverBackground: '#FFF5EB',

  textPrimary: '#5D3A1A',
  textSecondary: '#8B5A2B',
  textMuted: '#A67951',

  borderColor: '#F9C98B',

  shadow:
    '0 1px 3px 0 rgba(244, 162, 97, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.14)',
  shadowLg:
    '0 10px 25px -5px rgba(244, 162, 97, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)',

  primaryHover: '#E89250', // --primary-hover
  primaryStrong: '#C4631A', // --primary-strong (deep amber-orange, gradient endpoint)
  accentColor: '#E76F51', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(244, 162, 97, 0.22), 0 2px 6px -1px rgba(0, 0, 0, 0.18)', // --shadow-md
  shadowXl:
    '0 20px 50px -10px rgba(244, 162, 97, 0.4), 0 12px 20px -8px rgba(0, 0, 0, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(244, 162, 97, 0.12)', // --shadow-soft

  primaryLight: 'rgba(244, 162, 97, 0.14)',
  unreadBackground: 'rgba(244, 162, 97, 0.06)',
  messageBubbleBg: '#FFF5EB',
  messageReceivedBg: '#ffffff',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
};

export const darkTheme = {
  name: 'dark',

  primaryColor: '#F4A261',
  primaryDark: '#E76F51',
  secondaryColor: '#F9C98B',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#F9C98B',

  bgPrimary: '#1A0F08',
  bgSecondary: '#2D1B0F',
  bgTertiary: '#3F2816',

  background: '#1A0F08',
  cardBackground: '#2D1B0F',
  hoverBackground: '#3F2816',

  textPrimary: '#FFF0E0',
  textSecondary: '#F9C98B',
  textMuted: '#E5A874',

  borderColor: '#8B5A2B',

  shadow: '0 1px 3px 0 rgba(244, 162, 97, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.8)',
  shadowLg:
    '0 18px 35px -10px rgba(0, 0, 0, 0.9), 0 0 40px rgba(244, 162, 97, 0.35)',

  primaryHover: '#FFB87A', // --primary-hover
  primaryStrong: '#FF8C3A', // --primary-strong (vivid amber, gradient endpoint)
  accentColor: '#F9C98B', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(244, 162, 97, 0.3), 0 2px 6px -1px rgba(0, 0, 0, 0.6)', // --shadow-md
  shadowXl:
    '0 28px 60px -14px rgba(0, 0, 0, 0.9), 0 0 60px rgba(244, 162, 97, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(244, 162, 97, 0.2)', // --shadow-soft

  primaryLight: 'rgba(244, 162, 97, 0.3)',
  unreadBackground: 'rgba(244, 162, 97, 0.16)',
  messageBubbleBg: '#3F2816',
  messageReceivedBg: '#523620',
  dangerLight: 'rgba(239, 68, 68, 0.25)',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
